<template>
  <SatisfactionComp :type="type" :qrcode="qrcode" />
</template>

<script>
import { buddhistSatisfactionQrcodeUrl } from "./data/satisfaction";
import SatisfactionComp from "./layouts/SatisfactionComp.vue";

export default {
  name: "BuddhistSatisfaction",
  components: { SatisfactionComp },
  data() {
    return {
      type: 2,
      qrcode: buddhistSatisfactionQrcodeUrl,
    };
  },
};
</script>

<style lang="less" scoped></style>
